export const BizAid = () => (
  <svg
    className="bizaid"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 784.53 138.76"
  >
    <line className="cls-1" y1="69.38" x2="672" y2="69.38" />
    <path
      className="cls-1"
      d="M101.73,1H61.56A28.22,28.22,0,0,0,33.34,29.22V69.38H73.51a28.22,28.22,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(54.19 21.9)">
      <tspan className="cls-3">A</tspan>
      <tspan className="cls-4" x="3.43" y="0">
        IT
      </tspan>
      <tspan className="cls-5" x="8.29" y="0">
        K
      </tspan>
      <tspan className="cls-6" x="12.03" y="0">
        I
      </tspan>
      <tspan x="13.98" y="0">
        N{' '}
      </tspan>
      <tspan className="cls-7" x="18.9" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="22.4" y="0">
        O
      </tspan>
      <tspan x="25.94" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(53.59 54.84)">
      <tspan className="cls-9">2</tspan>
      <tspan x="3.38" y="0">
        0{' '}
      </tspan>
      <tspan className="cls-10" x="7.84" y="0">
        G
      </tspan>
      <tspan className="cls-11" x="11.33" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="15.02" y="0">
        AN
      </tspan>
      <tspan className="cls-12" x="22.48" y="0">
        T
      </tspan>
      <tspan className="cls-13" x="25.38" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(42.37 36.85)">
      <tspan className="cls-15">$</tspan>
      <tspan className="cls-16" x="6.66" y="0">
        2
      </tspan>
      <tspan className="cls-17" x="13.19" y="0">
        00
      </tspan>
      <tspan className="cls-18" x="26.82" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="30.09" y="0">
        00
      </tspan>
      <tspan x="43.72" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="42.71" y1="43.3" x2="92.36" y2="43.3" />
    <path
      className="cls-1"
      d="M232.59,1H192.43a28.21,28.21,0,0,0-28.22,28.22V69.38h40.16a28.21,28.21,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(186.5 21.9)">
      <tspan className="cls-7">C</tspan>
      <tspan className="cls-19" x="3.5" y="0">
        O
      </tspan>
      <tspan className="cls-20" x="7.03" y="0">
        O
      </tspan>
      <tspan x="10.53" y="0">
        K{' '}
      </tspan>
      <tspan className="cls-7" x="15.16" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="18.66" y="0">
        O
      </tspan>
      <tspan x="22.2" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(184.26 54.84)">
      <tspan className="cls-5">1</tspan>
      <tspan className="cls-13" x="2.96" y="0">
        4{' '}
      </tspan>
      <tspan className="cls-21" x="7.51" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="11" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.69" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="22.15" y="0">
        T
      </tspan>
      <tspan x="25.05" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(173.37 36.85)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-25" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-26" x="12.4" y="0">
        4
      </tspan>
      <tspan className="cls-17" x="19.51" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="26.32" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="29.59" y="0">
        00
      </tspan>
      <tspan x="43.23" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="173.57" y1="43.3" x2="223.23" y2="43.3" />
    <path
      className="cls-1"
      d="M363.46,1H323.29a28.22,28.22,0,0,0-28.22,28.22V69.38h40.17a28.22,28.22,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(306.07 21.9)">
      <tspan className="cls-27">K</tspan>
      <tspan className="cls-28" x="3.68" y="0">
        OO
      </tspan>
      <tspan className="cls-29" x="10.74" y="0">
        C
      </tspan>
      <tspan className="cls-30" x="14.2" y="0">
        H
      </tspan>
      <tspan className="cls-20" x="18.08" y="0">
        I
      </tspan>
      <tspan className="cls-27" x="20.05" y="0">
        C
      </tspan>
      <tspan className="cls-31" x="23.52" y="0">
        H
      </tspan>
      <tspan className="cls-6" x="27.39" y="0">
        I
      </tspan>
      <tspan className="cls-32" x="29.34" y="0">
        N
      </tspan>
      <tspan x="33.31" y="0">
        G{' '}
      </tspan>
      <tspan className="cls-7" x="37.75" y="0">
        C
      </tspan>
      <tspan className="cls-33" x="41.25" y="0">
        O
      </tspan>
      <tspan className="cls-13" x="44.79" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(315.23 54.84)">
      <tspan className="cls-34">2</tspan>
      <tspan x="3.45" y="0">
        1{' '}
      </tspan>
      <tspan className="cls-21" x="7.3" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="10.78" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.47" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="21.94" y="0">
        T
      </tspan>
      <tspan x="24.84" y="0">
        S
      </tspan>
    </text>
    <text className="cls-35" transform="translate(304.57 36.85)">
      $
      <tspan className="cls-36" x="6.66" y="0">
        2
      </tspan>
      <tspan className="cls-37" x="13.33" y="0">
        1
      </tspan>
      <tspan className="cls-17" x="18.84" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="25.65" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="28.92" y="0">
        00
      </tspan>
      <tspan className="cls-38" x="42.56" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="304.44" y1="43.3" x2="354.09" y2="43.3" />
    <path
      className="cls-1"
      d="M494.32,1H454.16a28.21,28.21,0,0,0-28.22,28.22V69.38H466.1a28.21,28.21,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(434.02 21.9)">
      <tspan className="cls-32">N</tspan>
      <tspan className="cls-20" x="3.97" y="0">
        O
      </tspan>
      <tspan className="cls-39" x="7.47" y="0">
        R
      </tspan>
      <tspan className="cls-40" x="11.14" y="0">
        T
      </tspan>
      <tspan x="13.97" y="0">
        H{' '}
      </tspan>
      <tspan className="cls-41" x="18.83" y="0">
        S
      </tspan>
      <tspan className="cls-42" x="22.29" y="0">
        T
      </tspan>
      <tspan className="cls-13" x="24.9" y="0">
        .{' '}
      </tspan>
      <tspan className="cls-43" x="27.56" y="0">
        L
      </tspan>
      <tspan className="cls-28" x="30.25" y="0">
        O
      </tspan>
      <tspan className="cls-44" x="33.78" y="0">
        U
      </tspan>
      <tspan className="cls-45" x="37.29" y="0">
        I
      </tspan>
      <tspan x="39.29" y="0">
        S{' '}
      </tspan>
      <tspan className="cls-46" x="43.58" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="47.08" y="0">
        O
      </tspan>
      <tspan x="50.62" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(444.52 54.84)">
      <tspan className="cls-47">1</tspan>
      <tspan className="cls-5" x="2.95" y="0">
        1
      </tspan>
      <tspan className="cls-13" x="5.91" y="0">
        4{' '}
      </tspan>
      <tspan className="cls-21" x="10.46" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="13.94" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="17.64" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="25.1" y="0">
        T
      </tspan>
      <tspan x="28" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(431.12 36.85)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-48" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-49" x="12.3" y="0">
        ,
      </tspan>
      <tspan className="cls-50" x="14.67" y="0">
        1
      </tspan>
      <tspan className="cls-26" x="20.36" y="0">
        4
      </tspan>
      <tspan className="cls-17" x="27.47" y="0">
        0
      </tspan>
      <tspan className="cls-51" x="34.29" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="37.56" y="0">
        00
      </tspan>
      <tspan x="51.19" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="435.3" y1="43.3" x2="484.96" y2="43.3" />
    <path
      className="cls-1"
      d="M625.19,1H585A28.22,28.22,0,0,0,556.8,29.22V69.38H597a28.22,28.22,0,0,0,28.22-28.22Z"
    />
    <text className="cls-2" transform="translate(570.08 21.9)">
      <tspan className="cls-40">T</tspan>
      <tspan className="cls-28" x="2.83" y="0">
        R
      </tspan>
      <tspan className="cls-52" x="6.4" y="0">
        I
      </tspan>
      <tspan className="cls-28" x="8.35" y="0">
        B
      </tspan>
      <tspan className="cls-53" x="12.04" y="0">
        A
      </tspan>
      <tspan x="15.47" y="0">
        L{' '}
      </tspan>
      <tspan className="cls-54" x="19.02" y="0">
        N
      </tspan>
      <tspan className="cls-55" x="23.06" y="0">
        A
      </tspan>
      <tspan className="cls-40" x="26.31" y="0">
        T
      </tspan>
      <tspan className="cls-20" x="29.13" y="0">
        IO
      </tspan>
      <tspan className="cls-56" x="34.61" y="0">
        N
      </tspan>
      <tspan x="38.61" y="0">
        S
      </tspan>
    </text>
    <text className="cls-2" transform="translate(580.42 54.84)">
      1{' '}
      <tspan className="cls-21" x="3.85" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="7.33" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="11.02" y="0">
        AN
      </tspan>
      <tspan x="18.49" y="0">
        T
      </tspan>
    </text>
    <text className="cls-14" transform="translate(569.61 36.85)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-37" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-17" x="12.21" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="19.03" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="22.3" y="0">
        00
      </tspan>
      <tspan x="35.93" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="566.17" y1="43.3" x2="615.82" y2="43.3" />
    <path
      className="cls-1"
      d="M783.11,69.38l-41.05-41a40.78,40.78,0,0,0-57.69,0L643.31,69.38l41.06,41.06a40.79,40.79,0,0,0,57.69,0Z"
    />
    <text className="cls-57" transform="translate(704.46 53.7)">
      <tspan className="cls-58">TO</tspan>
      <tspan className="cls-59" x="7.51" y="0">
        T
      </tspan>
      <tspan className="cls-60" x="10.56" y="0">
        A
      </tspan>
      <tspan x="14.56" y="0">
        L
      </tspan>
    </text>
    <text className="cls-57" transform="translate(694.72 92.56)">
      <tspan className="cls-61">3</tspan>
      <tspan className="cls-62" x="4" y="0">
        8
      </tspan>
      <tspan x="8.2" y="0">
        1{' '}
      </tspan>
      <tspan className="cls-63" x="12.74" y="0">
        G
      </tspan>
      <tspan className="cls-64" x="16.8" y="0">
        R
      </tspan>
      <tspan className="cls-60" x="21.1" y="0">
        AN
      </tspan>
      <tspan className="cls-65" x="29.8" y="0">
        T
      </tspan>
      <tspan x="33.17" y="0">
        S
      </tspan>
    </text>
    <text className="cls-66" transform="translate(678.08 71.34)">
      <tspan className="cls-67">$</tspan>
      <tspan className="cls-68" x="7.84" y="0">
        3
      </tspan>
      <tspan className="cls-69" x="15.69" y="0">
        ,
      </tspan>
      <tspan className="cls-70" x="19.56" y="0">
        8
      </tspan>
      <tspan className="cls-71" x="27.78" y="0">
        1
      </tspan>
      <tspan className="cls-72" x="34.26" y="0">
        0
      </tspan>
      <tspan className="cls-73" x="42.29" y="0">
        ,
      </tspan>
      <tspan className="cls-74" x="46.13" y="0">
        00
      </tspan>
      <tspan x="62.19" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="683.92" y1="78.95" x2="742.5" y2="78.95" />
    <path
      className="cls-1"
      d="M167.16,137.76V97.6a28.23,28.23,0,0,0-28.22-28.22H98.78v40.16A28.21,28.21,0,0,0,127,137.76Z"
    />
    <text className="cls-75" transform="translate(116.37 90.28)">
      C
      <tspan className="cls-3" x="3.5" y="0">
        A
      </tspan>
      <tspan className="cls-4" x="6.93" y="0">
        L
      </tspan>
      <tspan className="cls-39" x="9.59" y="0">
        R
      </tspan>
      <tspan className="cls-76" x="13.26" y="0">
        T
      </tspan>
      <tspan className="cls-20" x="16.12" y="0">
        O
      </tspan>
      <tspan className="cls-77" x="19.62" y="0">
        N{' '}
      </tspan>
      <tspan className="cls-7" x="24.54" y="0">
        C
      </tspan>
      <tspan className="cls-33" x="28.04" y="0">
        O
      </tspan>
      <tspan className="cls-13" x="31.58" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(119.11 123.22)">
      <tspan className="cls-78">2</tspan>
      <tspan className="cls-13" x="3.43" y="0">
        7{' '}
      </tspan>
      <tspan className="cls-10" x="6.94" y="0">
        G
      </tspan>
      <tspan className="cls-11" x="10.42" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.11" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="21.58" y="0">
        T
      </tspan>
      <tspan x="24.48" y="0">
        S
      </tspan>
    </text>
    <text className="cls-35" transform="translate(108.56 105.23)">
      $
      <tspan className="cls-79" x="6.66" y="0">
        2
      </tspan>
      <tspan className="cls-80" x="13.29" y="0">
        7
      </tspan>
      <tspan className="cls-17" x="18.27" y="0">
        0
      </tspan>
      <tspan className="cls-18" x="25.09" y="0">
        ,
      </tspan>
      <tspan className="cls-81" x="28.36" y="0">
        00
      </tspan>
      <tspan className="cls-38" x="41.99" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="108.14" y1="111.68" x2="157.79" y2="111.68" />
    <path
      className="cls-1"
      d="M298,137.76V97.6A28.22,28.22,0,0,0,269.8,69.38H229.64v40.16a28.22,28.22,0,0,0,28.22,28.22Z"
    />
    <text className="cls-2" transform="translate(249.85 90.28)">
      <tspan className="cls-82">I</tspan>
      <tspan className="cls-83" x="2.03" y="0">
        T
      </tspan>
      <tspan className="cls-53" x="4.68" y="0">
        AS
      </tspan>
      <tspan className="cls-84" x="11.5" y="0">
        C
      </tspan>
      <tspan x="15.01" y="0">
        A{' '}
      </tspan>
      <tspan className="cls-46" x="19.32" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="22.82" y="0">
        O
      </tspan>
      <tspan x="26.37" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(249.47 123.22)">
      <tspan className="cls-85">6</tspan>
      <tspan x="3.5" y="0">
        0{' '}
      </tspan>
      <tspan className="cls-21" x="7.96" y="0">
        G
      </tspan>
      <tspan className="cls-11" x="11.45" y="0">
        R
      </tspan>
      <tspan className="cls-53" x="15.14" y="0">
        AN
      </tspan>
      <tspan className="cls-12" x="22.6" y="0">
        T
      </tspan>
      <tspan x="25.5" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(238.48 105.23)">
      <tspan className="cls-25">$</tspan>
      <tspan className="cls-48" x="6.57" y="0">
        6
      </tspan>
      <tspan className="cls-17" x="13.33" y="0">
        00
      </tspan>
      <tspan className="cls-18" x="26.96" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="30.23" y="0">
        00
      </tspan>
      <tspan x="43.86" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="239.01" y1="111.68" x2="288.66" y2="111.68" />
    <path
      className="cls-1"
      d="M428.89,137.76V97.6a28.23,28.23,0,0,0-28.22-28.22H360.51v40.16a28.21,28.21,0,0,0,28.22,28.22Z"
    />
    <text className="cls-2" transform="translate(380.71 90.28)">
      <tspan className="cls-86">L</tspan>
      <tspan className="cls-53" x="2.77" y="0">
        AK
      </tspan>
      <tspan className="cls-13" x="9.94" y="0">
        E{' '}
      </tspan>
      <tspan className="cls-7" x="13.67" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="17.17" y="0">
        O
      </tspan>
      <tspan x="20.71" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(380.33 123.22)">
      <tspan className="cls-87">1</tspan>
      <tspan x="2.88" y="0">
        0{' '}
      </tspan>
      <tspan className="cls-21" x="7.34" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="10.82" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="14.52" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="21.98" y="0">
        T
      </tspan>
      <tspan x="24.88" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(369.35 105.23)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-37" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-17" x="12.21" y="0">
        00
      </tspan>
      <tspan className="cls-18" x="25.84" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="29.11" y="0">
        00
      </tspan>
      <tspan x="42.75" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="369.87" y1="111.68" x2="419.52" y2="111.68" />
    <path
      className="cls-1"
      d="M559.75,137.76V97.6a28.22,28.22,0,0,0-28.22-28.22H491.37v40.16a28.22,28.22,0,0,0,28.22,28.22Z"
    />
    <text className="cls-2" transform="translate(500.73 90.28)">
      <tspan className="cls-3">S</tspan>
      <tspan className="cls-19" x="3.4" y="0">
        O
      </tspan>
      <tspan className="cls-88" x="6.93" y="0">
        U
      </tspan>
      <tspan className="cls-40" x="10.53" y="0">
        T
      </tspan>
      <tspan x="13.35" y="0">
        H{' '}
      </tspan>
      <tspan className="cls-41" x="18.21" y="0">
        S
      </tspan>
      <tspan className="cls-42" x="21.67" y="0">
        T
      </tspan>
      <tspan x="24.28" y="0">
        .{' '}
      </tspan>
      <tspan className="cls-43" x="26.95" y="0">
        L
      </tspan>
      <tspan className="cls-28" x="29.63" y="0">
        O
      </tspan>
      <tspan className="cls-89" x="33.16" y="0">
        U
      </tspan>
      <tspan x="36.73" y="0">
        S{' '}
      </tspan>
      <tspan className="cls-46" x="41.02" y="0">
        C
      </tspan>
      <tspan className="cls-8" x="44.52" y="0">
        O
      </tspan>
      <tspan x="48.06" y="0">
        .
      </tspan>
    </text>
    <text className="cls-2" transform="translate(509.95 123.22)">
      <tspan className="cls-47">1</tspan>
      <tspan className="cls-5" x="2.95" y="0">
        1
      </tspan>
      <tspan className="cls-13" x="5.91" y="0">
        4{' '}
      </tspan>
      <tspan className="cls-21" x="10.46" y="0">
        G
      </tspan>
      <tspan className="cls-22" x="13.94" y="0">
        R
      </tspan>
      <tspan className="cls-3" x="17.64" y="0">
        AN
      </tspan>
      <tspan className="cls-23" x="25.1" y="0">
        T
      </tspan>
      <tspan x="28" y="0">
        S
      </tspan>
    </text>
    <text className="cls-14" transform="translate(496.55 105.23)">
      <tspan className="cls-24">$</tspan>
      <tspan className="cls-48" x="6.71" y="0">
        1
      </tspan>
      <tspan className="cls-49" x="12.3" y="0">
        ,
      </tspan>
      <tspan className="cls-50" x="14.67" y="0">
        1
      </tspan>
      <tspan className="cls-26" x="20.36" y="0">
        4
      </tspan>
      <tspan className="cls-17" x="27.47" y="0">
        0
      </tspan>
      <tspan className="cls-51" x="34.29" y="0">
        ,
      </tspan>
      <tspan className="cls-17" x="37.56" y="0">
        00
      </tspan>
      <tspan x="51.19" y="0">
        0
      </tspan>
    </text>
    <line className="cls-1" x1="500.74" y1="111.68" x2="550.39" y2="111.68" />
    <path
      className="cls-1"
      d="M195.31,69.38a6.71,6.71,0,0,1,4.74,2,5.37,5.37,0,0,1,0,7.58,4.29,4.29,0,0,1-6.06,0,3.43,3.43,0,0,1,0-4.85,2.75,2.75,0,0,1,3.88,0,2.2,2.2,0,0,1,0,3.1"
    />
    <path
      className="cls-1"
      d="M602.78,69.38a6.71,6.71,0,0,1,4.74,2,5.37,5.37,0,0,1,0,7.58,4.29,4.29,0,0,1-6.06,0,3.43,3.43,0,0,1,0-4.85,2.75,2.75,0,0,1,3.88,0,2.2,2.2,0,0,1,0,3.1"
    />
    <path
      className="cls-1"
      d="M389,69.38a6.66,6.66,0,0,0,4.73-2,5.37,5.37,0,0,0,0-7.58,4.29,4.29,0,0,0-6.06,0,3.43,3.43,0,0,0,0,4.85,2.75,2.75,0,0,0,3.88,0,2.18,2.18,0,0,0,0-3.1"
    />
    <path className="cls-1" d="M258.48,64a5.42,5.42,0,0,1-5.42,5.42" />
    <path className="cls-1" d="M631.66,64a5.42,5.42,0,0,1-5.42,5.42" />
    <path className="cls-1" d="M475.6,69.38A5.42,5.42,0,0,1,481,74.8" />
    <path className="cls-1" d="M8.33,74.8a5.42,5.42,0,0,1,5.42-5.42" />
  </svg>
);
